/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '@dm/core';
import { PipesModule } from 'app/common/pipes/pipes.module';

import { SelectUserOrGroupModule } from '../../select-user-or-group/select-user-or-group.module';
import { CreateFrontTableUserQuotaComponent } from './create-front-table-user-quota.component';

@NgModule({
    declarations: [CreateFrontTableUserQuotaComponent],
    exports: [CreateFrontTableUserQuotaComponent],
    imports: [
        CommonModule,
        CoreModule,
        ReactiveFormsModule,
        SelectUserOrGroupModule,
        PipesModule,
    ],
})
export class CreateFrontTableUserQuotaModule { }
